import cls from 'classnames';
import propTypes from 'prop-types';
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { CDN_BASE_URL } from '@/constants';
import Button from '../button';

import styles from './index.module.scss';

const GUIDE_CONTENT = ['', '关闭对话框哦', '发送语音给老师哦', '查看本课常见问题哦', '发送工程文件给老师哦', '一键发送截图给老师哦'];
const Guide = ({ hasShowedGuide, onFinished, opening }) => {
  const [step, setStep] = useState(1);
  const handleFinished = () => {
    window.localStorage.setItem('hasViewedImGuide', true);
    if (onFinished) {
      onFinished();
    }
  };
  const handleNextStep = () => {
    if (step) {
      setStep(step + 1);
    }
  };
  return opening && !hasShowedGuide && ReactDOM.createPortal(
    <div className={styles.container}>
      <img className={styles.img} src={`${CDN_BASE_URL}/im-guide.png`} />
      <div className={cls(styles.guideContent, styles[`guideContent${step}`])} style={{ backgroundImage: `url(${CDN_BASE_URL}/im-guide-${step}.png?v2)` }}>
        <p>点击这里可以</p>
        <p>{GUIDE_CONTENT[step]}</p>
        <div className={styles.btns}>
          {step < 5 ? (
            <>
              <Button className={cls(styles.skip, styles.btn)} size="m" onClick={handleFinished} theme="">跳过</Button>
              <Button className={cls(styles.next, styles.btn)} size="m" onClick={handleNextStep} theme="">继续</Button>
            </>
          ) : (
            <Button className={cls(styles.next, styles.btn)} size="m" onClick={handleFinished} theme="">完成</Button>
          )}
        </div>
      </div>
      <img className={cls(styles.ellipse, styles[`ellipse${step}`])} src={`${CDN_BASE_URL}/im-guide-ellipse.png`} />
    </div>,
    document.body
  );
};
Guide.propTypes = {
  hasShowedGuide: propTypes.bool,
  onFinished: propTypes.func,
  opening: propTypes.bool,
};

export default Guide;
